// extracted by mini-css-extract-plugin
module.exports = {"zoomBtn":"ZoomBtn_zoomBtn__2uD_8"};